import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { queryClient } from '@/lib/query-client';
import { ROUTES } from '@/routes/paths';
import { useAuthStore } from '@/stores/auth-store';

/**
 * Cerrar sesión en el cliente: borra el token persistido, vacía la caché de queries
 * (para no mostrar datos de la cuenta anterior) y vuelve a /login.
 *
 * El backend no tiene endpoint de logout: el JWT es stateless y sigue siendo válido hasta
 * que expira (`JWT_EXPIRES_IN`). Si algún día hace falta invalidarlo de verdad, habría que
 * añadir una lista de revocados en el backend.
 */
export function useLogout() {
  const navigate = useNavigate();

  return useCallback(() => {
    useAuthStore.getState().clearSession();
    queryClient.clear();
    navigate(ROUTES.login, { replace: true });
  }, [navigate]);
}
